package components.project.configuration

import components.form.commentSection
import it.neckar.commons.kotlin.js.safeGet
import it.neckar.lizergy.model.configuration.quote.QuoteConfiguration
import it.neckar.lizergy.model.project.ResolvedProject
import react.*
import react.dom.*

/**
 * Shows the preview for *one* quote
 */
val ConfigurationPreviewWithComments: FC<ConfigurationPreviewWithCommentsProps> = fc("ConfigurationPreviewWithComments") { props ->
  val project = props::project.safeGet()
  val quoteConfiguration = props::quoteConfiguration.safeGet()


  div("row my-3") {

    if (quoteConfiguration != null) {
      div("col-lg-6") {
        ConfigurationPreview {
          attrs {
            this.project = project
            this.quoteConfiguration = quoteConfiguration
          }
        }
      }

      div("col-lg-6") {
        commentSection(quoteConfiguration)
      }
    } else {
      div("col-lg-6") {
        div("alert alert-danger") {
          +"Kein Angebot vorhanden!"
        }
      }
    }
  }

}

external interface ConfigurationPreviewWithCommentsProps : Props {
  var project: ResolvedProject
  var quoteConfiguration: QuoteConfiguration?
}
